import { render, staticRenderFns } from "./NewTrainingProgram.vue?vue&type=template&id=3ca3f2eb"
import script from "./NewTrainingProgram.vue?vue&type=script&lang=js"
export * from "./NewTrainingProgram.vue?vue&type=script&lang=js"
import style0 from "./NewTrainingProgram.vue?vue&type=style&index=0&id=3ca3f2eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports